module.exports = __webpack_public_path__ + "img/tutorials.e2973ae8.png";